import React from 'react'

const ProformaInvoices = () => (
  <div>{/*<img alt="cataloge" src={`${require('../../assets/ZadigCatalogue.jpg')}`} />*/}</div>
)

export default ProformaInvoices
